import React, { useEffect, useState, useCallback } from 'react';
import { supabase } from '../../lib/supabase';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { Checkbox } from '../../components/ui/Checkbox';
import { useAuth } from '../../contexts/AuthContext';

const ArtistProfileSettings = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  const [genresStr, setGenresStr] = useState('');

  const load = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    setError(null);
    try {
      const { data, error: e } = await supabase.from('artist_profiles').select('*').eq('user_id', user.id).single();
      if (e) throw e;
      setProfile(data);
      setGenresStr((data.genres || []).join(', '));
    } catch (e) {
      setError(e.message);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(()=>{ load(); }, [load]);

  const save = async () => {
    if (!user || !profile) return;
    setSaving(true); setError(null);
    try {
      const genres = genresStr.split(',').map(g=>g.trim()).filter(Boolean);
      const updatePayload = {
        genres,
        cachet_min: profile.cachet_min || null,
        cachet_max: profile.cachet_max || null,
        is_public: profile.is_public
      };
      const { error: e } = await supabase.from('artist_profiles').update(updatePayload).eq('user_id', user.id);
      if (e) throw e;
    } catch(e){ setError(e.message); } finally { setSaving(false); }
  };

  if (loading) return <div className="p-6">Chargement...</div>;
  if (error) return <div className="p-6 text-red-500">{error}</div>;
  if (!profile) return <div className="p-6">Profil artiste introuvable.</div>;

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Paramètres profil artiste</h1>
      <div className="space-y-4 bg-card border border-border rounded-lg p-4">
        <div className="flex items-center gap-2">
          <Checkbox id="is_public" checked={!!profile.is_public} onChange={e=>setProfile(p=>({...p,is_public:e.target.checked}))} />
          <label htmlFor="is_public" className="text-sm">Profil public</label>
        </div>
        <div>
          <label className="text-xs uppercase block mb-1">Genres (séparés par des virgules)</label>
          <Input value={genresStr} onChange={e=>setGenresStr(e.target.value)} placeholder="rock, pop, electro" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs uppercase block mb-1">Cachet min (€)</label>
            <Input type="number" value={profile.cachet_min || ''} onChange={e=>setProfile(p=>({...p,cachet_min:e.target.value?parseInt(e.target.value,10):null}))} />
          </div>
            <div>
            <label className="text-xs uppercase block mb-1">Cachet max (€)</label>
            <Input type="number" value={profile.cachet_max || ''} onChange={e=>setProfile(p=>({...p,cachet_max:e.target.value?parseInt(e.target.value,10):null}))} />
          </div>
        </div>
        <Button onClick={save} disabled={saving}>{saving ? 'Enregistrement...' : 'Enregistrer'}</Button>
        {error && <div className="text-xs text-red-500">{error}</div>}
      </div>
    </div>
  );
};

export default ArtistProfileSettings;